import { render, staticRenderFns } from "./BorrarTaquillero.vue?vue&type=template&id=ec739ca0"
import script from "./BorrarTaquillero.vue?vue&type=script&lang=js"
export * from "./BorrarTaquillero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports